import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, DatePicker, Button, Row, Col, InputNumber, notification } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {useAddCostSurchargeMutation} from '../../features/api/apiSlice';

function AddSurchargeModal({ open, setOpen }) {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const { RangePicker } = DatePicker;
    const [AddCostSurcharge , {
        isError: AddCostSurchargeIsError,
        isSuccess: AddCostSurchargeSuccess,
        error: AddCostSurchargeError,
        isLoading: AddCostSurchargeIsLoading,
        isFetching: AddCostSurchargeIsFetching,
    }] = useAddCostSurchargeMutation();

    useEffect(() => {
        if (!open) {
            form.resetFields();
        }
    }, [open, form]);
    useEffect(() => {
        if(AddCostSurchargeSuccess){
            notification.success({
                message: 'Success',
                description: '新增附加费成功'
            })
            setLoading(false)
            setOpen(false)
            form.resetFields()
        }
        if(AddCostSurchargeIsError){
            notification.error({
                message: 'Error',
                description: AddCostSurchargeError?.data?.error || '新增附加费失败'
            })
            setLoading(false)
        }
    }, [AddCostSurchargeSuccess, AddCostSurchargeIsError]);

    const handleCancel = () => {
        setOpen(false);
    };

    const handleOk = () => {
        form.validateFields().then(values => {
            setLoading(true);
            // 处理表单数据
            const formData = new FormData();

            // 处理新的数据结构，每个surcharge项都包含service和effective_date
            const processedSurcharges = values.surcharges.map(item => {
                return {
                    ...item,
                    effective_date: {
                        start_date: item.effective_date[0].format('YYYY-MM-DD'),
                        end_date: item.effective_date[1].format('YYYY-MM-DD')
                    }
                };
            });
            console.log(processedSurcharges)

            formData.append('surcharges', JSON.stringify(processedSurcharges));
            // formData.append('id', id)
            AddCostSurcharge(formData)

            // 发送请求到后端
            // axios.post('/accounts/add-surcharge/', formData)
            //     .then(res => {
            //         notification.success({
            //             message: '添加成功',
            //             description: '附加费添加成功',
            //         });
            //         setOpen(false);
            //     })
            //     .catch(err => {
            //         console.log(err);
            //         notification.error({
            //             message: '添加失败',
            //             description: err.response?.data?.error || '请联系管理员',
            //         });
            //     })
            //     .finally(() => {
            //         setLoading(false);
            //     });
        }).catch(error => {
            console.log('Validate Failed:', error);
        });
    };

    // 验证只能输入数字且最多两位小数
    const validateNumber = (_, value) => {
        if (value === undefined || value === null || value === '') {
            return Promise.reject('请输入数值');
        }
        if (!/^\d+(\.\d{1,2})?$/.test(value.toString())) {
            return Promise.reject('只能输入数字且最多两位小数');
        }
        return Promise.resolve();
    };

    return (
        <Modal
            title="新增附加费"
            open={open}
            onCancel={handleCancel}
            onOk={handleOk}
            confirmLoading={loading}
            width={800}
            destroyOnClose={true}
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={{
                    surcharges: [{}] // 默认一行
                }}
            >
                <Form.List name="surcharges">
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map(({ key, name, ...restField }) => (
                                <div key={key}>
                                    <Row gutter={16} align="middle">
                                        <Col span={8}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'service']}
                                                label="Service"
                                                rules={[{ required: true, message: '请选择服务' }]}
                                            >
                                                <Select placeholder="请选择服务">
                                                    <Select.Option key="FedEx Ground®" value="FEDEX Ground">
                                                        FEDEX Ground®
                                                    </Select.Option>
                                                    <Select.Option key="FedEx Home Delivery®  (FedEx Ground Service)" value="FEDEX Home Delivery">
                                                        FEDEX Home Delivery®  (FedEx Ground Service)
                                                    </Select.Option>
                                                    <Select.Option key="FedEx GE" value="FEDEX GE">
                                                        FEDEX GE
                                                    </Select.Option>
                                                    <Select.Option key="Fedex GE+" value="FEDEX GE+">
                                                        FEDEX GE+
                                                    </Select.Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={14}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'effective_date']}
                                                label="生效时间"
                                                rules={[{ required: true, message: '请选择生效时间' }]}
                                            >
                                                <RangePicker
                                                    style={{ width: '100%' }}
                                                    placeholder={['开始日期', '结束日期']}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={2} style={{ textAlign: 'right', marginTop: '30px' }}>
                                            {fields.length > 1 ? (
                                                <MinusCircleOutlined onClick={() => remove(name)} />
                                            ) : null}
                                        </Col>
                                    </Row>
                                    <Row gutter={16} align="middle">
                                        <Col span={6}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'surcharge']}
                                                label="Surcharge"
                                                rules={[
                                                    { required: true, message: '请输入附加费名称' },
                                                    { max: 20, message: '长度不能超过20个字符' }
                                                ]}
                                            >
                                                <Input placeholder="请输入附加费名称" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={3}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'zone2']}
                                                label="Zone2"
                                                rules={[{ required: true, validator: validateNumber }]}
                                            >
                                                <InputNumber 
                                                    placeholder="Zone2" 
                                                    style={{ width: '100%' }} 
                                                    precision={2}
                                                    min={0}
                                                    prefix="$"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={3}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'zone3']}
                                                label="Zone3"
                                                rules={[{ required: true, validator: validateNumber }]}
                                            >
                                                <InputNumber 
                                                    placeholder="Zone3" 
                                                    style={{ width: '100%' }} 
                                                    precision={2}
                                                    min={0}
                                                    prefix="$"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={3}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'zone4']}
                                                label="Zone4"
                                                rules={[{ required: true, validator: validateNumber }]}
                                            >
                                                <InputNumber 
                                                    placeholder="Zone4" 
                                                    style={{ width: '100%' }} 
                                                    precision={2}
                                                    min={0}
                                                    prefix="$"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={3}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'zone5']}
                                                label="Zone5"
                                                rules={[{ required: true, validator: validateNumber }]}
                                            >
                                                <InputNumber 
                                                    placeholder="Zone5" 
                                                    style={{ width: '100%' }} 
                                                    precision={2}
                                                    min={0}
                                                    prefix="$"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={3}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'zone6']}
                                                label="Zone6"
                                                rules={[{ required: true, validator: validateNumber }]}
                                            >
                                                <InputNumber 
                                                    placeholder="Zone6" 
                                                    style={{ width: '100%' }} 
                                                    precision={2}
                                                    min={0}
                                                    prefix="$"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={3}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'zone7+']}
                                                label="Zone7+"
                                                rules={[{ required: true, validator: validateNumber }]}
                                            >
                                                <InputNumber 
                                                    placeholder="Zone7+" 
                                                    style={{ width: '100%' }} 
                                                    precision={2}
                                                    min={0}
                                                    prefix="$"
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <div style={{ borderBottom: '1px dashed #d9d9d9', marginBottom: '20px', marginTop: '10px' }}></div>
                                </div>
                            ))}
                            <Form.Item>
                                <Button 
                                    type="dashed" 
                                    onClick={() => add()} 
                                    block 
                                    icon={<PlusOutlined />}
                                >
                                    添加附加费
                                </Button>
                            </Form.Item>
                        </>
                    )}
                </Form.List>
            </Form>
        </Modal>
    );
}

export default AddSurchargeModal;